import { Geography } from "@local-logic/client/dist/features/geographies";

export const extractLevelFromGeography = (
  locale: "en" | "fr",
  level: number,
  geographies: { [key: string]: Geography },
  geographyId?: string
) => {
  const findGeography = geographyId
    ? geographies[geographyId]
    : Object.values(geographies || {}).find(
        (geography) => geography.level === level
      );

  return findGeography?.name?.[locale] ?? "";
};
